/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Tr_SolverInputs */

const en_cp_tr_solver = /** @type {(inputs: Cp_Tr_SolverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problem Solver — solve a problem`)
};

const id_cp_tr_solver = /** @type {(inputs: Cp_Tr_SolverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Problem Solver — pecahkan masalah`)
};

/**
* | output |
* | --- |
* | "Problem Solver — solve a problem" |
*
* @param {Cp_Tr_SolverInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_tr_solver = /** @type {((inputs?: Cp_Tr_SolverInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Tr_SolverInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_tr_solver(inputs)
	return en_cp_tr_solver(inputs)
});